<div [ngClass]="{ 'm-portlet mb-4': settings?.isPortlet }">
    <div [ngClass]="{ 'm-portlet__body': settings?.isPortlet }">
        <div class="row">
            <div *ngIf="settings?.isSearch" class="col-lg-9" [ngClass]="settings?.isDateSelection ? 'col-lg-9' : 'col-lg-12'">
                <input (keyup)="updateFilter($event)" type="text" autofocus placeholder="Iskanje ...." class="form-control m-input" />
            </div>

            <div *ngIf="settings?.isDateSelection" class="col-lg-3">
                <div class="m-input-icon m-input-icon--left">
                    <input
                        [options]="options"
                        (selected)="selectedDate($event, daterangeCal)"
                        type="text"
                        name="daterangeInput"
                        daterangepicker
                        class="form-control m-input"
                    />
                    <span class="m-input-icon__icon m-input-icon__icon--left">
                        <span>
                            <i class="la la-calendar"></i>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
